import axios from 'axios'
import { empty2null } from './util'
import { hostname, statichostname } from './const'
import { Message } from 'element-ui'
import router from '@/router'


const debugBaseUrl = window.localStorage.getItem('debugBaseUrl')

const service = axios.create({
  baseURL: debugBaseUrl || hostname, //process.env.BASE_API,
  withCredentials: true,
  timeout: 60000,
})

service.interceptors.request.use(
  (config) => {
    if (config.empty2null) {
      empty2null(config.data)
    }

    // 统一加操作模块 - 页面对应的权限标识
    config.headers.mode = router.history.current.meta.permission || ''
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    // 接受流文件
    if (response.headers['content-type'] == "application/octet-stream") {
      return response
    }
    if (response.data.code == 501 || response.data.code == '501') {
      window.location.href = statichostname + '/#/login'
    }
    if (response.data.code == 51) {
      window.location.href = statichostname + '/#/403'
    }

    // 5001 修改密码
    if (response.status == 200 && response.data.code !== 0 && response.data.code !== 5001 && response.data.code !== 'suc') {
      Message({
        message: response.data.msg ? (`${response.data.msg}${response.data.subcode ? ` . ${response.data.subcode}` : ''}`) : 'Bad Request',
        type: 'error',
      })
      return Promise.reject(response.data)
    }

    return response.data
  },
  (error) => {
    Message({
      message: error.response.statusText || error.response.data.error || 'System Busy',
      type: 'error',
    })
    return Promise.reject(error)
  }
)

export default service
